module.exports = __webpack_public_path__ + "img/y-209.4a4af645.png";